import { render, staticRenderFns } from "./HealthDetailBlock.vue?vue&type=template&id=397d2c92&scoped=true&"
import script from "./HealthDetailBlock.vue?vue&type=script&lang=js&"
export * from "./HealthDetailBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397d2c92",
  null
  
)

export default component.exports